function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4-4h24v24H-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#898B91",
  strokeWidth: 1.5,
  d: "M13.808 1.333H2.192a.86.86 0 00-.859.859v11.616a.86.86 0 00.859.859h11.616a.86.86 0 00.859-.86V2.193a.86.86 0 00-.859-.859z"
}));

function SvgCheckboxUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgCheckboxUnchecked;